import { Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-expense-type-selector',
    templateUrl: './expense-type-selector.component.html',
    styleUrls: ['./expense-type-selector.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ExpenseTypeSelectorComponent),
            multi: true
        }
    ],
    encapsulation: ViewEncapsulation.None
})
export class ExpenseTypeSelectorComponent implements ControlValueAccessor {
    value: string = null;
    disabled: boolean = false;
    onChange: any = () => { };
    onTouch: any = () => { };

    /**
     * @description Si es true, se muestran los tipos de gasto de los empleados.
     * Por defecto, se muestran los tipos de gasto de la empresa.
     */
    @Input() empleado: boolean = false;

    // Método para escribir el valor desde el formulario al componente
    writeValue(value: string): void {
        this.value = value || null;
    }

    // Método para registrar el cambio de valor
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    // Método para registrar cuando se toca el control
    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    // Método para deshabilitar el control
    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    // Método para seleccionar un tipo de gasto
    // ... resto del código ...

    selectExpenseType(type: string): void {
        if (this.disabled) {
            return;
        }

        this.value = type;
        this.onChange(type);
        this.onTouch();

        // Para debug
        console.log('Tipo seleccionado:', type);
        console.log('Valor actual:', this.value);
    }
}
